import { useState, useRef, useMemo, useEffect } from "react"
import arrayUtilities from "../../utilities/arrayUtilities";
import stringHelpers from "../../utilities/stringHelpers";

export const SearchSelect = ({ buttonText, options, selected, onSelect, defaultLabel= "Select an option", width, isDisabled=false}) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const componentRef = useRef(null);
    // options should be an array of objects
    // where each object has a value property and a label property
    // value is what gets passed back to the parent component to make the CRUD change as needed
    // similar to "value" attribute in a regular <select> component
    // label is the display string within the dropdown

 
    const filteredOptions = useMemo(() => {
        if (stringHelpers.isNullOrEmpty(searchQuery)) return options;

        return options.filter(option =>
            option.label.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [searchQuery, options]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (componentRef.current && !componentRef.current.contains(event.target)) {
                setSearchQuery('');
                setIsOpen(false);
            }
        };

        const handleKeyPress = (event) => {
            if (event.code === 'Escape') {
                setSearchQuery('');
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keyup', handleKeyPress)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('keyup', handleKeyPress)
        };
    }, []);

    const handleSelect = (option) => {
        setSearchQuery('');
        setIsOpen(false);
        onSelect(option)
    };
    return (
        <div className="border rounded position-relative search-select" ref={ componentRef } style={{width: `${width !== undefined ? width : "100%"}`}}>
            <button disabled={isDisabled} onClick={ () => setIsOpen(!isOpen) } className={`btn btn-default d-flex align-items-center w-100 pl-2 pr-0 bg-white py-1 ${isOpen ? "is-open" : ""}`}>
                <p className="w-100 text-left m-0 fs--1">
                    { 
                        !stringHelpers.isNullOrEmpty(buttonText) ? buttonText
                        : !stringHelpers.isNullOrEmpty(selected) ? options.find(item => item.value === selected)?.label : defaultLabel}
                </p>
                { isOpen ? <i className="fas fa-chevron-up fs--2"></i> : <i className="fas fa-chevron-down fs--2"></i> }
            </button>
            {
                isOpen && (
                    <div className="px-0 border rounded bg-white position-absolute top-100 left-0 search-select-dropdown">
                        <div className="px-1 w-100">
                            <input
                                autoFocus
                                placeholder="Search..."
                                className="form-control my-2 px-2 fs--1 w-100" 
                                type="text"
                                value={ searchQuery }
                                onChange={ e => setSearchQuery(e.target.value) }
                            />
                        </div>
                        { 
                            !arrayUtilities.isNullOrEmpty(filteredOptions)
                            ? <ul className="pl-0 w-100 mb-2">                                 
                                {filteredOptions.map((option) => (
                                    <li
                                        key={ option.value }
                                        onClick={ () => handleSelect(option.value) }
                                        className={`dropdown-item cursor-pointer my-1 ml-0 pl-2 fs--1 ${selected === option.value ? "active" : ""}`}
                                    >
                                        { option.label }
                                    </li>
                                ))}
                            </ul>
                            : <p className="py-2 mb-2 fs--1 d-flex justify-content-center">No results found</p>
                        }
                    </div>
                ) }
        </div>
    )
}